import { render, staticRenderFns } from "./YachtInCharterRow.vue?vue&type=template&id=56ee47ba&scoped=true&"
import script from "./YachtInCharterRow.vue?vue&type=script&lang=js&"
export * from "./YachtInCharterRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee47ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
